module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp1_9016.ba7a967a.png";